import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ExportToCsv } from 'export-to-csv';
import { DtpNoContent } from 'dtp-react-components';
import {
  Button,
} from '../../../components/index';
import {
  doGet,
} from '../../../utils/requests';

class RelatorioControlePagamentos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showNoContent: false,
      noContentPrimaryMessage: null,
      noContentSecondaryMessage: null,
    };
  }

  tratarSucessoListaExportacao = (response) => {
    if (response.data !== '') {
      this.setState({
      }, this.gerarCsv(response.data));
    }
  };

  tratarErro = () => {
    const mensagemPrimaria = 'Não foi possível consultar os envios ao GET.';
    const mensagemSecundaria = 'Contate o administrador do sistema.';
    this.setState({
      showNoContent: true,
      noContentPrimaryMessage: mensagemPrimaria,
      noContentSecondaryMessage: mensagemSecundaria,
    });
  };

  colunasExportacaoDefault = [
    'idProtocolo',
    'dataEntradaFila',
    'dataEnvioGet',
    'dataRetornoComprev',
    'url',
    'bodyEnvio',
    'retorno',
    'pendente',
  ];

formatarProtocolo = (protocolo) => {
  let protocoloFormatado = '';
  if (protocolo) {
    protocoloFormatado = `{"${protocolo}"}`;
    protocoloFormatado = `${protocoloFormatado}`;
  }
  return protocoloFormatado;
};

defineListaParaExportacao = (lista) => {
  const listaOriginal = lista;
  const resultado = [];
  listaOriginal.forEach((envio) => {
    resultado.push({
      idProtocolo: envio.idProtocolo ? this.formatarProtocolo(envio.idProtocolo) : '',
      dataEntradaFila: envio.dataEntradaFila,
      dataEnvioGet: envio.dataEnvioGet !== undefined ? envio.dataEnvioGet : '',
      dataRetornoComprev: envio.dataRetornoComprev !== undefined ? envio.dataRetornoComprev : '',
      url: envio.url,
      bodyEnvio: envio.bodyEnvio,
      retorno: envio.retorno,
      pendente: envio.pendente,
    });
  });

  return resultado;
};

exportar = () => {
  if (Object.entries(this.props.filtrosConsulta).length !== 0) {
    doGet(
      'fila-do-get/exportacao-csv',
      this.tratarSucessoListaExportacao,
      this.tratarErro,
      {
        ...this.props.filtrosConsulta,
      },
    );
  }
};

gerarCsv = (lista) => {
  let dadosRelatorio = null;
  const legenda = 'Fila de envios ao GET';

  if (lista && lista !== undefined && lista.length > 0) {
    dadosRelatorio = this.defineListaParaExportacao(lista);
  } else {
    dadosRelatorio = [];
  }


  if (dadosRelatorio && dadosRelatorio !== undefined && dadosRelatorio.length > 0) {
    const csvExporter = new ExportToCsv({
      filename: 'Fila de envios ao GET',
      fieldSeparator: ';',
      showTitle: true,
      title: legenda,
      showLabels: true,
      headers: this.colunasExportacaoDefault,
    });
    csvExporter.generateCsv(dadosRelatorio);
  }
}

render() {
  if (this.state.showNoContent) {
    return (
      <DtpNoContent
        primaryText={this.state.noContentPrimaryMessage}
        secondaryText={this.state.noContentSecondaryMessage}
        show={this.state.showNoContent}
      />);
  }
  return (
    <React.Fragment>
      <div className="row">
        <Button
          hint="Exportar para CSV"
          onClick={() => { this.exportar(); }}
          icon="ico-doc-sheet"
          mini
        />
      </div>
    </React.Fragment>
  );
}
}

RelatorioControlePagamentos.propTypes = {
  voltarAction: PropTypes.func,
  filtrosConsulta: PropTypes.object,
}.isRequired;

RelatorioControlePagamentos.defaultProps = {
  voltarAction: () => null,
};

export default RelatorioControlePagamentos;



// WEBPACK FOOTER //
// ./src/pages/consultas/exportacao-csv/RelatorioFilaGet.jsx